import resolveFormInputs from '@hbrisk/sp3-risk-model-support/utility/form/resolveFormInputs/index.js';
import byField from '@hbrisk/sp3-risk-model-support/utility/form/formInputsTransforms/byField/index.js';
import bySlice from '@hbrisk/sp3-risk-model-support/utility/form/formInputsTransforms/bySlice/index.js';
import { MODEL_NAME } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import getFieldPermissionOverrides from '#src/js/support/utility/form/getFieldPermissionOverrides/index.js';
import { modelTypesById } from '#constants/models/modelTypes/index.js';

const calculateCopyModelPostPayload = (baseModel, createdById, orgId, permissions) => {
  const {
    type,
    formInputs,
    uploadedStructuralResponses,
    uploadedGroundMotionId,
    uploadedModeShapeId,
  } = baseModel;
  const { [MODEL_NAME]: originalModelName } = formInputs;

  let newModelFormInputs = {
    ...formInputs,
    [MODEL_NAME]: {
      ...originalModelName,
      value: `${originalModelName.value} Copy`,
    },
  };
  const { fields } = modelTypesById[type];
  newModelFormInputs = bySlice(newModelFormInputs);

  const overrides = getFieldPermissionOverrides(fields, permissions);

  newModelFormInputs = resolveFormInputs(fields, {
    ...newModelFormInputs,
    visibleFields: {
      ...newModelFormInputs.visibleFields,
      ...overrides,
    },
  });

  newModelFormInputs = byField(newModelFormInputs, fields);

  return {
    createdById,
    orgId,
    type,
    formInputs: newModelFormInputs,
    uploadedStructuralResponses,
    uploadedGroundMotionId,
    uploadedModeShapeId,
  };
};

export default calculateCopyModelPostPayload;
